<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">分红设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>股东信息</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-date-picker
          v-model="date"
          type="date"
          value-format="timestamp"
          placeholder="选择日期"
        >
        </el-date-picker>
        <el-input v-model="userid" placeholder="请输入用户ID"></el-input>
        <el-button type="primary" @click="handleSearch({ page: 1 })">
          查询
        </el-button>
        <!-- <el-button type="primary" @click="handleCalculate">
          计算用户团队持有量
        </el-button>
        <el-button type="primary" @click="handleCheck">
          检查股东级别
        </el-button> -->
      </div>
      <el-table :data="shareholderList">
        <el-table-column prop="userId" label="用户ID"> </el-table-column>
        <el-table-column prop="type" label="股东等级">
          <template slot-scope="scope">
            {{ types[scope.row.type] }}
          </template>
        </el-table-column>
        <el-table-column prop="originType" label="原股东等级">
          <template slot-scope="scope">
            {{ types[scope.row.originType] || '普通用户' }}
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.createTime | moment }}
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :size="pagination.size"
        :page="pagination.page"
        :total="totalCount"
        @pageChanged="handlePageChanged"
      >
      </pagination>
    </el-card>
  </div>
</template>
<script>
import './store';
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'DividendShareholder',
  data() {
    return {
      date: null,
      userid: '',
      types: {
        3: '初级股东',
        4: '中级股东',
        5: '高级股东'
      }
    };
  },
  components: {
    Pagination
  },
  methods: {
    ...mapActions('dividendShareholder', ['list', 'check', 'calculate']),
    handleSearch(data = {}) {
      this.list({
        date: this.date,
        userid: this.userid,
        ...this.pagination,
        ...data
      });
    },
    handlePageChanged(pagination) {
      this.list({
        date: this.date,
        userid: this.userid,
        ...this.pagination,
        ...pagination
      });
    },
    handleCalculate() {
      this.calculate(this.date);
    },
    handleCheck() {
      this.check(this.date);
    }
  },
  computed: {
    ...mapState('dividendShareholder', [
      'pagination',
      'totalCount',
      'shareholderList'
    ])
  }
};
</script>
<style lang="less" scoped></style>
